<pmd-navbar class="navbar-expand-xl pmd-z-depth-4 navbar-light bg-white" id="navbar">
  <div class="container-fluid">
    <div class="">
      <!-- Navbar Toggler -->
      <button
        tabindex="0"
        pmd-btn
        pmdRipple
        pmd-btn-fab
        pmd-btn-flat
        size="xs"
        class="pmd-sidebar-toggle d-xl-none pmd-btn-rounded"
        (click)="toggleSideBar()"
        [attr.aria-label]="'LAYOUT.HOME.NAV_BAR_TOGGLE_LABEL' | translate"
      >
        <i class="material-icons-round md-dark">menu</i>
      </button>
      <!-- Navbar brand -->
      <pmd-navbar-brand>
        <a
          tabindex="0"
          class="navbar-brand"
          [routerLink]="appGlobals.homePath"
          aria-label="ProBanker simulation logo"
        >
          <img
            src="assets/images/probanker-logo.svg"
            width="200"
            height="32"
            class="d-none d-md-inline-block align-center"
            alt="Probanker Logo"
          />
          <img
            src="assets/images/probanker-logo-icon.svg"
            width="32"
            height="32"
            class="d-inline-block d-md-none align-center logo-icon"
            alt="Probanker Logo Icon"
          />
        </a>
      </pmd-navbar-brand>
    </div>
    <pmd-navbar-right-icon class="d-flex">
      <div class="d-flex align-items-center me-3" *ngIf="isImpersonated">
        <button
          tabindex="0"
          type="button"
          size="sm"
          color="primary"
          pmd-btn-raised
          aria-label="Press enter to access as myself"
          (click)="originate()"
          id="impersonation"
        >
          Revoke Impersonation
        </button>
      </div>

      <!-- Notifications -->
      <div
        class="dropdown pmd-notification-dropdown pmd-dropdown mt-auto mb-auto"
        *ngIf="!loggedinUser.isPlayer"
      >
        <button
          type="button"
          routerLink="/course/requests"
          size="sm"
          color="light"
          pmd-btn-rounded
          aria-labelledby="requset_message"
          class="dropdown-toggle pmd-badge pmd-badge-overlap pmd-badge-secondary btn-notification"
          id="notificationDropdown"
        >
          <i class="material-icons-round pmd-icon-sm">notifications</i>
          <span class="notification-number">{{ requestCount }}</span>
        </button>
        <label id="requset_message" class="hiddenlabel">{{
          'COURSE.REQUEST.COURSE_REQUEST' | translate
        }}</label>
      </div>

      <!-- <form class="language-dropdown-form">
				<app-language></app-language>
			</form> -->

      <!-- Logged in User Information -->
      <div class="dropdown pmd-dropdown pmd-user-info" pmdDropdown>
        <a
          tabindex="0"
          [routerLink]="null"
          pmdDropdownToggle
          class="btn-user p-0 dropdown-toggle d-flex align-items-center"
          aria-labelledby="user_dropdown"
          id="userNavbarDropdown"
        >
          <div class="pmd-avatar" aria-hidden="true" *ngIf="loggedinUser.profileImage">
            <img
              [src]="loggedinUser.profileImage"
              width="40"
              height="40"
              class="img-fluid"
              data-src="holder.js/40x40"
              alt="40x40"
            />
          </div>
          <div
            class="pmd-avatar pmd-avatar-secondary"
            aria-hidden="true"
            *ngIf="!loggedinUser.profileImage"
          >
            {{ loggedinUser.shortName }}
          </div>
          <div class="flex-grow-1 d-none d-md-block ms-3">
            <p class="mb-0 fw-bold text-dark">
              {{ loggedinUser.name }}
            </p>
            <p pmd-card-subtitle>
              {{ loggedinUser.role | uppercase | translate }}
            </p>
          </div>
          <i class="material-icons ms-2 pmd-icon-sm text-gray d-none d-md-block" aria-hidden="true"
            >more_vert</i
          >
        </a>
        <label id="user_dropdown" class="hiddenlabel">{{
          'LAYOUT.HOME.DROPDOWN_LABEL' | translate
        }}</label>
        <ul
          class="dropdown-menu dropdown-menu-right"
          *pmdDropdownMenu
          aria-labelledby="userNavbarDropdown"
          role="menu"
        >
          <li>
            <a
              tabindex="0"
              class="dropdown-item d-flex align-items-center"
              routerLinkActive="active"
              routerLink="/profile"
              pmdRipple
              aria-label="Press enter to view profile"
              role="menuitem"
            >
              <span class="material-icons me-2" aria-hidden="true"> person </span>
              {{ 'LAYOUT.HOME.MY_PROFILE' | translate }}
            </a>
          </li>
          <li>
            <a
              tabindex="0"
              class="dropdown-item d-flex align-items-center"
              routerLinkActive="active"
              pmdRipple
              aria-label="Press enter to logout from the tool"
              role="menuitem"
              (click)="logout()"
              (keydown.enter)="logout()"
            >
              <span class="material-icons me-2" aria-hidden="true">logout</span>
              {{ 'LAYOUT.HOME.LOGOUT' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </pmd-navbar-right-icon>
  </div>
</pmd-navbar>
